export default {"src":"/_next/static/media/visit.d1bf69f9.svg","height":47,"width":48,"blurWidth":0,"blurHeight":0};